var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.mapaStyleLeaflet)?_c('Mapa'):_vm._e(),(_vm.mapaStyleMaps)?_c('GoogleMaps'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }